import React from 'react';

// Интерфейсы для описания типов данных
interface LinkProps {
  href: string;
  target?: string;
  rel?: string;
}

interface ButtonStyle {
  primaryColor: string;
  secondaryColor: string;
}

interface PlatformButtonProps extends LinkProps {
  platformName: string;
  buttonStyle: ButtonStyle;
  id: string; // Добавлено уникальное ID для ключа
}

// Тип массива данных для кнопок
type PlatformButtonsArray = Array<PlatformButtonProps>;

// Компонент кнопки платформы
const PlatformButton = ({ platformName, buttonStyle, ...linkProps }: PlatformButtonProps) => (
  <a
    {...linkProps}
    className="platform-button"
    style={{
      backgroundColor: buttonStyle.primaryColor,
      color: buttonStyle.secondaryColor,
      borderRadius: '8px',
      padding: '1rem 2rem',
      fontWeight: 'bold',
      textDecoration: 'none',
      transition: 'background-color 0.3s ease',
    }}
  >
    {platformName}
  </a>
);

// Компонент секции контактов
const ContactSection = ({ profileLinks }: { profileLinks: PlatformButtonsArray }) => {
  return (
    <section id="contact" className="section section-dark">
      <div className="container">
        <div className="section-header">
          <div className="section-badge">Свяжитесь со мной</div>
          <h2>
            Давайте обсудим
            <span className="title-accent"> ваш проект!</span>
          </h2>
          <p className="description">
            Напишите мне напрямую или найдите меня на профессиональных площадках:
          </p>
          <ul className="contact-details">
            <li><strong>Kwork:</strong> Посмотрите мои готовые услуги и отзывы клиентов.</li>
            <li><strong>Профи.ру:</strong> Оцените мой рейтинг и опыт работы.</li>
            <li><strong>YouDo:</strong> Найдите мои выполненные задания.</li>
            <li><strong>ВКонтакте:</strong> Добавляйтесь в друзья или пишите в личные сообщения.</li>
          </ul>
        </div>

        <div className="contact-platforms">
          {profileLinks.map(link => (
            <PlatformButton key={link.id} {...link} />
          ))}
        </div>
      </div>
    </section>
  );
};

// Данные для контактных кнопок
const contactData: PlatformButtonsArray = [
  {
    id: 'kwork',
    platformName: 'Kwork',
    buttonStyle: { primaryColor: '#00D2FF', secondaryColor: '#3A7BD5' },
    href: 'https://kwork.ru/user/minin-ok',
    target: '_blank',
    rel: 'noreferrer noopener',
  },
  {
    id: 'profi',
    platformName: 'Профи.ру',
    buttonStyle: { primaryColor: '#FF6B6B', secondaryColor: '#FFFFFF' },
    href: 'https://profi.ru/profile/MininokVO',
    target: '_blank',
    rel: 'noreferrer noopener',
  },
  {
    id: 'youdo',
    platformName: 'YouDo',
    buttonStyle: { primaryColor: '#00C853', secondaryColor: '#FFFFFF' },
    href: 'https://youdo.com/u11423774',
    target: '_blank',
    rel: 'noreferrer noopener',
  },
  {
    id: 'vk',
    platformName: 'VK',
    buttonStyle: { primaryColor: '#4C75A3', secondaryColor: '#FFFFFF' },
    href: 'https://vk.com/id110330980',
    target: '_blank',
    rel: 'noreferrer noopener',
  },
];

// Экспорт главного компонента
export default function Contact(): JSX.Element {
  return <ContactSection profileLinks={contactData} />;
}